import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store/index';
import { Provider } from 'react-redux';
import ReactGa from 'react-ga4';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from "./components/ScrollToTop";

// GA4 script is loaded in index.html, ReactGa will use it
const trackingId = process.env.REACT_APP_GA_TRACKING_ID || ""; // Use env or fallback


// Initialize Google Analytics
if (trackingId) {
  ReactGa.initialize(trackingId, { debug: process.env.NODE_ENV === 'development' });
} else {
  console.warn('Google Analytics tracking ID not found. GA events will not be sent.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
    <ScrollToTop />
      <App />
    </BrowserRouter>
  </Provider>
);
const SendAnalytics = () => {
  const fullPath = window.location.pathname + window.location.search; // Capture query params
  console.log("Sending pageview for:", fullPath);
  ReactGa.send({ hitType: "pageview", page: fullPath });
};

// Track initial page load
SendAnalytics();

// Track route changes
window.addEventListener("popstate", SendAnalytics);
// Capture performance metrics
reportWebVitals(SendAnalytics);
